export default __webpack_public_path__ + "static/media/areasgestao.8481c2c2.svg";